import {buildAuthenticationHeaders, dashboardAxios} from "@/api/global";


const getFeatureFlag = (credentials, feature) =>
    dashboardAxios.get(`/messages-10dlc/api/account/${credentials.accountId}/flag/${feature}`, {
        ...buildAuthenticationHeaders(credentials)
    });

export {
    getFeatureFlag
};
